<div class="wf-table-card">
  <table class="wf-table">
    <thead>
      <tr>
        <th>Arquivo</th>
        <th class="col-type">Etapa</th>
        <th class="col-user">Anexado por</th>
        <th class="col-date">Data/Hora</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let anexo of anexos">
        <td>{{ anexo.nomeArquivo }}</td>
        <td class="col-type">{{ anexo.etapa }}</td>
        <td class="col-user">{{ anexo.anexadoPor }}</td>
        <td class="col-date">{{ anexo.dataHora | date: 'dd/MM HH:mm' }}</td>
      </tr>
    </tbody>
  </table>
</div>
